/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';
import getSiteConfig from '../../app/pages/Account/utils/getSiteConfig';

const composePersonalizedContent = async (payload) => {
    const { token: jwtToken, ...reqBody } = payload;
    const resourcePage = 'compose-personalized-content';

    const siteConfig = getSiteConfig();

    const wcEnv = {
        protocol: 'https',
        prefix: '/r/api/flowers-gpt/api',
        rootUri: '/',
        brand: siteConfig.domain,
    };

    const response = await restClient.postFacade(wcEnv, resourcePage, jwtToken, reqBody, null, null, false);

    return response;
};

export default composePersonalizedContent;
